import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './home/home.component';
import {ReviewsBlockComponent} from './shared/reviews-block/reviews-block.component';
import { ExpertkltpComponent } from './expertkltp/expertkltp.component';
import {RecallFormComponent} from './shared/recall-form/recall-form.component';
import {AtomkaCalcComponent} from './calcs/atomka-calc/atomka-calc.component';
import { EventsComponent } from './events/events.component';
import { TehusComponent } from './tehus/tehus.component';
import { ExpertpdComponent } from './expertpd/expertpd.component';
import { ExpprombezComponent } from './expprombez/expprombez.component';
import { ZisComponent } from './zis/zis.component';
import { EpbKotlovComponent } from './epb-kotlov/epb-kotlov.component';
import { ExpertdeclComponent } from './expertdecl/expertdecl.component';
import { EpbSosudovComponent } from './epb-sosudov/epb-sosudov.component';
import { EpbGazoprovodovComponent } from './epb-gazoprovodov/epb-gazoprovodov.component';
import { EpbGpmComponent } from './epb-gpm/epb-gpm.component';
import { TekhDiComponent } from './tekh-di/tekh-di.component';
import { TdGazComponent } from './td-gaz/td-gaz.component';
import { ObRezervuarovComponent } from './ob-rezervuarov/ob-rezervuarov.component';
import { ObKotlovComponent } from './ob-kotlov/ob-kotlov.component';
import { TeplpsetComponent } from './teplpset/teplpset.component';
import { LikOpoComponent } from './lik-opo/lik-opo.component';
import { LikOpoLikComponent } from './lik-opo-lik/lik-opo-lik.component';
import { KonservationComponent } from './konservation/konservation.component';
import { PerevorujComponent } from './perevoruj/perevoruj.component';
import { ContactsComponent } from './contacts/contacts.component';
import { ObZisComponent } from './ob-zis/ob-zis.component';
import { ObSosudovComponent } from './ob-sosudov/ob-sosudov.component';
import { ObTrubComponent } from './ob-trub/ob-trub.component';
import { ObGpmComponent } from './ob-gpm/ob-gpm.component';
import { IdentificationComponent } from './identification/identification.component';
import { AuditComponent } from './audit/audit.component';
import { PasportComponent } from './pasport/pasport.component';
import { OtzyvyComponent } from './otzyvy/otzyvy.component';
import { AboutComponent } from './about/about.component';
import {HttpClientModule} from "@angular/common/http";
import {EachOtzyvComponent} from "./otzyvy/each-otzyv/each-otzyv.component";
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ReviewsBlockComponent,
    ExpertkltpComponent,
    RecallFormComponent,
    AtomkaCalcComponent,
    EventsComponent,
    TehusComponent,
    ExpertpdComponent,
    ExpprombezComponent,
    ZisComponent,
    EpbKotlovComponent,
    ExpertdeclComponent,
    EpbSosudovComponent,
    EpbGazoprovodovComponent,
    EpbGpmComponent,
    TekhDiComponent,
    TdGazComponent,
    ObRezervuarovComponent,
    ObKotlovComponent,
    TeplpsetComponent,
    LikOpoComponent,
    LikOpoLikComponent,
    KonservationComponent,
    PerevorujComponent,
    ContactsComponent,
    ObZisComponent,
    ObSosudovComponent,
    ObTrubComponent,
    ObGpmComponent,
    IdentificationComponent,
    AuditComponent,
    PasportComponent,
    OtzyvyComponent,
    AboutComponent,
    EachOtzyvComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
